import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
// import Material from '@primeuix/themes/material';
// import Lara from '@primeuix/themes/lara';
// import Nora from '@primeuix/themes/nora';

export const Nsad = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#fdf6ec',
          100: '#faecd8',
          200: '#f5dbb2',
          300: '#f0c88b',
          400: '#eab766',
          500: '#C08B3F',
          600: '#a27435',
          700: '#865e2b',
          800: '#6a4821',
          900: '#503519',
          950: '#3e2813',
        },
        highlight: {
          background: '#C08B3F',
          focusBackground: '#a27435',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        custom: {
          cardcolor: '#fefcf9',
        },
      },
      dark: {
        primary: {
          50: '#fdf6ec',
          100: '#faecd8',
          200: '#f5dbb2',
          300: '#f0c88b',
          400: '#eab766',
          500: '#C08B3F',
          600: '#a27435',
          700: '#865e2b',
          800: '#6a4821',
          900: '#503519',
          950: '#3e2813',
        },
        highlight: {
          background: '#C08B3F',
          focusBackground: '#a27435',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        custom: {
          cardcolor: '#292524',
        },
      },
    },
  },
  components: {
    card: {
      colorScheme: {
        light: {
          root: {
            background: '{custom.cardcolor}',
            borderRadius: '8px',
          },
        },
        dark: {
          root: {
            background: '{custom.cardcolor}',
            borderRadius: '8px',
          },
        },
      },
    },
  },
});
